<!-- <p>### md-maps works!</p> -->

<google-map height="400px" width="100%" [options]="options">
    @for (position of markerPositions; track position) {
    <map-marker [position]="position" [options]="markerOptions" />
    }
</google-map>